import React, { ReactNode, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { matchRoutes } from "react-router-config";
import qs from "qs";
import AppContext from "./AppContext";
import {
    // useAuthToken,
    useHPAuth
} from './AppHooks';
import { Loader } from "../index";
import {
    // checkHPPermission,
    checkPermission
} from './Utils';
import { initialUrl, initialOuterUrl } from '../../shared/constants/AppConst';
import AppContextPropsType from "../../types/AppContextPropsType";
import { NavStyle, ThemeMode, ThemeStyle } from "../../shared/constants/AppEnums";
// import defaultConfig from './ContextProvider/defaultConfig';
//import {PaymentHandle} from '../../model/PaymentHandle';

interface AuthRoutesProps {
    children: ReactNode;
}

// const AuthRoutes: React.FC<AuthRoutesProps> = ({children}) => {
//     const {pathname, search} = useLocation();
//     const history = useHistory();
//     const {
//         routes,
//         changeNavStyle,
//         updateThemeStyle,
//         initialPath,
//         setInitialPath,
//         updateThemeMode,
//         setRTL
//     } = useContext<AppContextPropsType>(AppContext);

//     const [loading, user] = useAuthToken();
//     const currentRoute = matchRoutes(routes, pathname)[0].route;
//     let isPermitted = checkPermission(currentRoute.auth, user ? user.role : null);

//     useEffect(() => {
//         console.log({initialPath, pathname});
//         function setInitPath() {
//             const outerURLs = [
//                 '/login', '/register', '/otp', '/resetPassword',
//                 /*--- URL PRECONFIGURATI DEL TEMPLATE ---*/
//                 '/signin',
//                 '/signup',
//                 '/confirm-signup',
//                 '/reset-password',
//                 '/error-pages/error-404',
//                 '/forget-password',
//             ];
//             if (initialPath === '/' && outerURLs.indexOf(pathname) === -1) {
//                 console.log("initialPath = / && pathname included in outerURLs");
//                 if (isPermitted) {
//                     setInitialPath(pathname);
//                 } else {
//                     setInitialPath(undefined);
//                 }
//             }
//         }
//         setInitPath();
//     }, [ isPermitted, setInitialPath, initialPath, pathname]);

//     useEffect(() => {
//         function handleQueryParams() {
//             const query = qs.parse(search.split('?')[1]);
//             if (query.layout) {
//                 changeNavStyle(query.layout as NavStyle);
//             }
//             if (query.mode) {
//                 updateThemeMode(query.mode as ThemeMode);
//             }
//             if (query.rtl) {
//                 setRTL(true);
//             }
//             if (query.style) {
//                 updateThemeStyle!(query.style as ThemeStyle);
//             }
//         }

//         if (search) {
//             handleQueryParams();
//         }
//     }, [changeNavStyle, updateThemeMode, setRTL, updateThemeStyle, search]);

//     useEffect(() => {
//         if (!loading) {
//             if (!user && !isPermitted) {
//                 history.push(initialOuterUrl); // allowed route
//             } else if (user && !isPermitted) {
//                 history.push('/error-pages/error-404'); // Not found
//             } else if (user && isPermitted) {
//                 if (
//                   pathname === '/' ||
//                   pathname === '/signin' || pathname === '/login' ||
//                   pathname === '/signup'
//                 ) {
//                     history.push(initialUrl);
//                 } else {
//                     // @ts-ignore
//                     if (
//                       initialPath &&
//                       initialUrl !== initialPath &&
//                       initialPath !== '/'
//                       // initialPath !== '/signin' ||
//                       // initialPath !== '/signup')
//                     ) {
//                         history.push(initialPath);
//                     }
//                 }
//             }
//         }
//     }, [user, loading, initialPath, isPermitted, pathname, history]);

//     return loading ? <Loader /> : <>{children}</>;
// };

// export default AuthRoutes;


export const HPAuthRoutes: React.FC<AuthRoutesProps> = ({children}) => {
    const {pathname, search} = useLocation();
    const [loading, currentHPUser] = useHPAuth();
    const history = useHistory();
    const {
        routes,
        changeNavStyle,
        updateThemeStyle,
        initialPath,
        setInitialPath,
        updateThemeMode,
        setRTL,
        // HPUser,
        // HP_JWT
    } = useContext<AppContextPropsType>(AppContext);

    //const [loading, user] = useAuthToken();
    const routePath = matchRoutes(routes, pathname)[0];
    console.log("routePath", routePath);
    const currentRoute = matchRoutes(routes, pathname)[0].route;
    //let isPermitted = checkPermission(currentRoute.auth, user ? user.role : null);
    console.log("currentRoute", currentRoute);

    // let isPermitted = true;
    //let isPermitted = checkHPPermission(currentRoute.auth);
    //let isPermitted = checkHPPermission(routePath.route.path as string);
    let isPermitted = checkPermission(currentRoute.auth, currentHPUser ? currentHPUser.ruoli : null);
    console.log("isPermitted-->",isPermitted)
    console.log("checkPermission-->",checkPermission(currentRoute.auth, currentHPUser ? currentHPUser.ruoli : null))
    console.log("currentRoute-->",currentRoute)
    console.log("routePath-->",routePath)
    console.log("currentRoute.auth-->",currentRoute.auth)
    console.log("currentHPUser-->",currentHPUser)
    console.log("currentHPUser.ruolo-->",currentHPUser?.ruoli)

    const outerURLs = [
        '/login', '/register', '/passwordDimenticata', '/confermaRegistrazione',
        /*--- URL PRECONFIGURATI DEL TEMPLATE ---*/
        '/signin',
        '/signup',
        '/confirm-signup',
        '/reset-password',
        '/error-pages/error-404',
        '/error-pages/error-403',
        '/forget-password',
    ];

    useEffect(() => {
        console.log({initialPath, pathname});
        function setInitPath() {
            if (initialPath === '/' && outerURLs.includes(pathname)) {
                console.log("initialPath = '/' && pathname included in outerURLs");
                if (isPermitted) {
                    setInitialPath(pathname);
                } else {
                    setInitialPath(undefined);
                }
            }
        }
        setInitPath();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ isPermitted, setInitialPath, initialPath, pathname]);

    useEffect(() => {
        function handleQueryParams() {
            const query = qs.parse(search.split('?')[1]);
            if (query.layout) {
                changeNavStyle(query.layout as NavStyle);
            }
            if (query.mode) {
                updateThemeMode(query.mode as ThemeMode);
            }
            if (query.rtl) {
                setRTL(true);
            }
            if (query.style) {
                updateThemeStyle!(query.style as ThemeStyle);
            }
            console.log("QUERY: ", query);
            /*if(query.token && query.PayerID){
                console.warn("Going to se pending payment");
                setPendingPayment(new PaymentHandle({
                    payerId: query.PayerID as string,
                    token: query.token as string
                }))
            }*/
        }
        if (search) {
            handleQueryParams();
        }
    }, [changeNavStyle, updateThemeMode, setRTL, updateThemeStyle, search]);

    useEffect(() => {
        console.log({
            initialPath, initialUrl, initialOuterUrl, currentHPUser, isPermitted
        });
        if(!loading){
            if (!currentHPUser) {
                history.push(initialOuterUrl);
                // console.log("!HPUser");
                // if(!outerURLs.includes(pathname)){
                //     history.push(initialOuterUrl); // allowed route
                // } else {
                    // console.log("Going to sei initial path");
                    // setInitialPath('/');
                // }
            } else if (pathname === '/login') {
                history.push(initialUrl);
            } 
            /*else if (currentHPUser && !isPermitted) {
            console.log("HPUser && !isPermitted");
            history.push('/error-pages/error-404'); // Not found
        }*/ 
        if (currentHPUser && !isPermitted) {
                // console.log("HPUser && isPermitted");
                //if (pathname === '/' || pathname === '/signin' || pathname === '/signup') {
                
                // if (pathname === '/' || outerURLs.includes(pathname)) {
                //     console.log("pathname === '/' || pathname === '/signin' || pathname === '/signup'");
                //     history.push(initialUrl);
                // } else {
                //     console.log("pathname != '/' && pathname != '/signin' && pathname != '/signup'");
                //     // @ts-ignore
                //     if (initialPath && initialPath !== '/' && initialPath !== initialUrl /*initialPath !== '/signin' || initialPath !== '/signup'*/) {
                //         history.push(initialPath);
                //     }
                // }

                //403
                history.replace("/error-pages/error-403");
            } 
            // else {
            //     console.log("sono nell'else")
            // }
        }
    }, [currentHPUser, loading, initialPath, isPermitted, pathname, history]);

    //return /*loading ? <Loader /> : */<>{children}</>;
    return loading ? <Loader /> : <>{children}</>;
};
